export default __webpack_public_path__ + "static/media/percentile_icon.8769b5cc.svg";